import { createSlice } from "@reduxjs/toolkit";
import { transactionAPI } from "../../api/customer";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const transactionSlice = createSlice({
  name: "transaction",
  initialState: data,
  reducers: {
    transactionSlice(state) {
      state.isLoading = true;
    },
    transactionSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    transactionSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    transactionSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const transactionHandler = (search: any, page: any, limit: any, sort_by:any,sort_direction:any,start_date: any, end_date: any) => async (dispatch: any) => {
  try {
    dispatch(transactionAction.transactionSlice());
    const response: any = await transactionAPI(search, page, limit,sort_by,sort_direction, start_date, end_date);
    dispatch(transactionAction.transactionSliceSuccess(response));
  } catch (e: any) {
    dispatch(transactionAction.transactionSliceFailure(e?.response?.data));
  }
};
export default transactionSlice.reducer;
export const transactionAction = transactionSlice.actions;
